/**
 * Разметка редактора Quill перед сохранением и отправкой.
 *
 * react-quill-new отдаёт в onChange результат `getSemanticHTML()`. В Quill 2.0.3
 * (последняя версия на 09.2026) эта функция заменяет каждый пробел в тексте на
 * `&nbsp;` — см. `convertHTML` в `quill/core/editor.js`:
 *
 *     return escapedText.replaceAll(' ', '&nbsp;');
 *
 * Неразрывный пробел не даёт строке переноситься, поэтому абзац, сохранённый в
 * таком виде, вытягивается в одну строку — и в просмотре новости, и в письме
 * подрядчику. Старый редактор (Quill 1) писал обычные пробелы.
 *
 * Возвращаем обычный пробел. Серию из нескольких пробелов подряд сохраняем
 * видимой: первый в серии — обычный (строка может перенестись), остальные —
 * неразрывные, иначе браузер схлопнул бы их в один.
 *
 * Править в onChange нельзя: редактор управляемый, и подмена значения на каждом
 * нажатии заставила бы его перерисовывать содержимое и сбрасывать курсор. Поэтому
 * функция зовётся там, где текст покидает редактор, — при сохранении и отправке.
 */
export const normalizeQuillHtml = (html: string): string =>
    html.replace(/(?:&nbsp;)+/g, (run) => {
        const count = run.length / "&nbsp;".length;
        return " " + "&nbsp;".repeat(count - 1);
    });
